<template>
  <div class="navbar-wrapper" id="tsection">
    <transition name="fade">
    <div class="active-nav" v-if="toggle">
      <div class="link shorthand">
        <div v-for="navItem in navMain" class="small-div">
          <a class="div-link" :href="[navItem.section ? '/?anchor=' + navItem.section : navItem.path]" @click="[ navItem.section ? onScrollTo($event, 'landing', navItem.section) : '']">
            {{ navItem.title }}
          </a>
        </div>
        <!-- <div class="small-div">
          <a class="div-link" href="/?anchor=section-show" @click="$event.preventDefault();onScrollTo('landing', 'section-show')">
            Shows
          </a>
        </div>
        <div class="small-div">
          <a class="div-link" href="/?anchor=section-contact" @click="$event.preventDefault();onScrollTo('landing', 'section-contact')">
            Contact
          </a>
        </div> -->
        <div class="small-div" v-if="false">
          <div>
            <a class="elink" :href="['mailto:' + navEmail]">{{ navEmail }}</a>
          </div>
        </div>
        <div class="small-div">
          <div class="eicon">
            <a v-for="navItem in navSocial" class="fa" :href="navItem.path" target="_blank">
              <i class="fa" :class="['fa-' + navItem.fa]" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <!-- // ticket cancelled -->
        <div class="small-div" v-if="toggle">
          <div class="eicon link-ticket-wrapper">
              <div class="bg">
                <img src="../assets/bg_ribbon.svg" width=200 />
              </div>
              <div class="text">
                <a href="/tickets">
                  Purchase Tickets
                </a>
              </div>
          </div>
        </div>

      </div>
    </div>
    </transition>
    <div class="full-layer">
      <navbar-full :toggle="toggle" @onToggle="toggle = $event"></navbar-full>
    </div>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import NavbarFull from './NavBarFull.vue'

export default {
  name: 'topsection',
  components: {
    'NavbarFull': NavbarFull
  },
  data () {
    return {
      toggle: false,
      navMain: EventBus._data._navMain,
      navSocial: EventBus._data._navSocial,
      navEmail: EventBus._data._navEmail
    }
  },
  watch: {
    toggle: function (val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  methods: {
    onScrollTo ($event, name, target) {
      $event.preventDefault()
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.toggle = !this.toggle
        var root = document.documentElement
        root.className = ''

        // this.$scrollTo(el)
        this.$scrollTo('#' + target, { offset: -50 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";

.topsection {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.topsection {
  min-height: 250px;
  width: 100%;
  height: auto;
  position: relative;
  background: transparent;
  margin-top: 50px;

  @media screen and (min-width: $desktop) {
    margin-top: 0;
  }
  & .ccontainer {
    max-width: 1152px !important;
    z-index: 1;
  }
}

$color-orange: #ffbc12;
$widescreen: 1200px;

#tsection {
  // this to workaround top bar positioning
  z-index: 20;
  width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  // this to workaround top bar positioning

  // min-height: 100vh;

  & .active-nav {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.9);
    z-index: 10;
    line-height: 1;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    display: flex;

    // landscape mobile
    @media (min-width: 480px) and (max-height: 420px) {
      padding-top: 5rem;
    }

    & .link a {
      color: $color-gray-light;
      font-size: 1.1em;
      display: block;
      margin-bottom: 0rem;

      @media screen and (min-width: $tablet) {
        margin-bottom: 1rem;
      }

      @media screen and (min-width: $desktop) {
        margin-bottom: 1rem;
      }
      // potrait
      @media (max-width: 420px) and (min-height: 480px) {
        margin-bottom: 1rem;

        // extra mini
        @media (max-width: 320px) {
          margin-bottom: 0rem;
        }
      }
      // landscape mobile
      @media (min-width: 480px) and (max-height: 420px) {
        margin-bottom: 1rem;
      }

      &:before {
        background-color: $color-white;
      }
      &:hover {
        color: $color-white;
      }
    }
    & .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      height: 100%;

      &.shorthand {
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-flex-direction: row;
        flex-direction: row;
        height: 50%;

        & .small-div {
          width: 100%;
          text-align: center;

          // potrait
          @media (max-width: 420px) and (min-height: 480px) {
            width: 100%;
          }
          // landscape mobile
          @media (min-width: 480px) and (max-height: 420px) {
            width: 50%;
          }

          & div,
          & .div-link {
            display: inline-block;
            font-family: $font-family-title;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            padding: 0.5rem;
          }
          &:first-child {
            // @media screen and (min-height: 601px) {
            margin-top: 2rem;

            @media screen and (min-width: $tablet) {
              margin-top: 2rem;
            }
            // potrait
            @media (max-width: 420px) and (min-height: 480px) {
              margin-top: 2rem;
            }
            // landscape mobile
            @media (min-width: 480px) and (max-height: 420px) {
              margin-top: 0rem;
            }
          }
          // &:nth-child(4) {
          //   margin-top: 2em;
          //   @media (min-width: 480px) and (max-height: 420px) {
          //     margin-top: 0rem;
          //   }
          // }
        }
      }
    }
    & .link .elink {
      &:before {
        background-color: $color-red;
      }
      &:hover {
        color: $color-gray-light;
      }
    }
    & .link .eicon {
      // custom for iphone 4 and 5
      & a {
        display: inline-block;
        margin-top: 1rem;
        margin-left: 1rem;
        margin-right: 1rem;
        &:before {
          height: 0;
        }
      }
      & i {
        font-size: 2rem;
        // width: 50px;
        // height: 50px;
        vertical-align: middle;
      }

      &.link-ticket-wrapper {
        position: relative;

        .bg {
          // width: 200px;
          // position: absolute;
          // top: 0px;
          // right: 0;
          //
          // img {
          //   width: 200px;
          // }
        }

        .text {
          position: absolute;
          top: 5px;
          right: 0;
          width: 100%;
          padding: 8px 15px;

          a {
            color: $color-black;

            &:hover {
              color: $color-gray;
            }
          }
        }
      }

    }
  }

  & .logo {
    padding: 0 30px;
    @media screen and (min-width: $desktop) {
      padding: 0;
    }
  }
  & .sub {
    padding: 30px 30px;
    @media screen and (min-width: $tablet) {
      padding-top: 50px;
      padding-left: 60px;
      padding-right: 60px;
    }
    @media screen and (min-width: $desktop) {
      padding-top: 50px;
      padding-left: 30px;
      padding-right: 30px;
    }
    @media screen and (min-width: $widescreen) {
      padding-top: 70px;
    }
  }
}

.full-layer {
  // min-height: 100vh;
  /*height: 100px;*/
  display: flex;
  flex-direction: column;

  // html.modal-open & {
  //   // this to remove scrollability
  //   pointer-events: none;
  // }
}
@media screen and (min-width: 1008px) {
  .topsection {
    min-height: calc(100vh - 135px);
  }
}
</style>



// WEBPACK FOOTER //
// NavBarOverlay.vue?7427fa2a